<div class="smione-privacy-policy-wrapper" role="main">

    <div class="modal-header p-0"><button (click)="close()" type="button" class="btn-close" aria-label="divHeader"><i class="fa fa-close"></i></button></div>
    <p *ngIf="isPrivatePolicy" class="mt-20">{{'DASHBOARD.PRIVACYPOLICY.PrivacyPolicy' | translate}}</p> 
    <!-- <p *ngIf="!isPrivatePolicy">{{'DASHBOARD.PRIVACYPOLICY.NonPrivacyPolicy' | translate}}</p>   -->
    <p *ngIf="!isPrivatePolicy"> {{'DASHBOARD.ATM.Model.Para1' | translate}} </p>
    <p *ngIf="!isPrivatePolicy"> {{'DASHBOARD.ATM.Model.Para2' | translate}} </p>
    <div class="modal-btn"><button cdkFocusInitial (click)="open()" type="button" class="green-btn"> {{'DASHBOARD.PRIVACYPOLICY.Continue' | translate}} </button></div>
    
</div>